<template>
  <FileManager></FileManager>
</template>

<script>
import FileManager from "@/components/FileManager/index.vue";

export default {
  components: {
    FileManager,
  },
};
</script>

<style></style>
